import React, { useEffect, useState } from "react";
import ReactJson from 'react-json-view'


const JsonRender = (props) => {

    const [JSON, setJSON] = useState([]);

    useEffect(() => {
        fetch(props.urlData).then(async (x) => {
            const data = await x.json()
            setJSON(data)
        });
    }, [props.urlData]);

    return (
        <div className="p-3">
            <ReactJson src={JSON} />
        </div>
    )
}

export default JsonRender;